import React from 'react'
import styled from 'styled-components'
import { Paper, Tooltip } from '@material-ui/core'
import { colors } from '../../styles'
import { P } from '../StyledText'
import Chip from '../StyledChip'

export const StyledPaper = styled(Paper)`
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  margin-top: 10px;
  left: 0;
  right: 0;
` as React.ComponentType<any>

export const StyledNoOption = styled(P)`
  padding: 12px 8px;
` as React.ComponentType<any>

export const StyledPlaceholder = styled(P)`
  color: ${colors.grey30};
  position: absolute;
  left: 2;
  font-size: 16px;
` as React.ComponentType<any>

export const StyledValueContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
  overflow: hidden;
` as React.ComponentType<any>

export const StyledInputWrapper = styled.div`
  display: flex;
  padding: 0;
` as React.ComponentType<any>

export const StyledChip = styled(({ isUppercase, ...rest }) => (
  <Chip {...rest} />
))`
  text-transform: ${({ isUppercase }: any) =>
    isUppercase ? 'uppercase' : 'none'};
  word-break: break-all;
` as React.ComponentType<any>

export const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip classes={{ popper: className, tooltip: 'tooltip' }} {...props} />
))`
  & .tooltip {
    font-size: 15px;
  }
` as React.ComponentType<any>
